import { Timeline } from '@powerportalspro/react-fluent';

const ACTIVITIES = ['appointment', 'task', 'phonecall'];

// The page's account's meetings, calls and tasks from now on, soonest first.
export function TimelineAscendingSample() {
  return <Timeline ascending defaultTables={ACTIVITIES} pageSize={6} maxHeight="480px" />;
}
